import React, { createRef, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { ModuleBreak } from "Components/Module";
import { ExploreModule } from "./ExploreModule";
import { MapModule } from "./MapModule";
import { QuestionsModule } from "./QuestionsModule";
import { ReservationModuleElement, ReservationsModule } from "./ReservationsModule";
import { ReviewsModule } from "./ReviewsModule";
import { SearchModule } from "./SearchModule";
import { SocialBanner } from "./SocialBanner";
import { SearchContextProvider } from "../Main/SearchContextProvider";
import { ThisWeekModule } from "./ThisWeekModule";
import { useSelector } from "react-redux";
import { socialActivityEnabledSelector } from "Utils/selectors";

export const Dashboard: React.FC = () => {
   const reservationModuleRef = createRef<ReservationModuleElement>();
   const socialActivityEnabled = useSelector(socialActivityEnabledSelector);

   const refreshUpcomingReservationList = () => {
      if (!!reservationModuleRef.current) {
         reservationModuleRef.current.refresh();
      }
   }

   const { search } = useLocation();
   const query = useMemo(() => new URLSearchParams(search), [search])

   return (<>
      <SearchContextProvider>
         <SocialBanner />
         <SearchModule initialAddress={query.get("search")} />
         <MapModule />
         <ModuleBreak />
         <ExploreModule refreshUpcomingReservationList={refreshUpcomingReservationList} />
         {  
            socialActivityEnabled 
            ? <ThisWeekModule />
            : <><ReservationsModule ref={reservationModuleRef} /></>
         }
      </SearchContextProvider>
      <ReviewsModule />
      <QuestionsModule />
   </>);
}